import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { myInfo, familyInfo } from 'src/static/sample/stepA';
import { dataSet, familyDataSet } from './dataSet';
import { error } from 'console';

const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

/**
 * Fetch: StepA
 */
export const fetchData = async (
  param: any,
  errorModalState: any,
  myInfoStore: any,
  familyInfoStore: any,
  loadingState: any,
  queryClient: any
) => {
  try {
    loadingState({ active: '_active' });
    await myInfoDataFn(errorModalState, param, myInfoStore, queryClient);
    await familyInfoDataFn(errorModalState, param, familyInfoStore, queryClient);
    loadingState({ active: '' });
  } catch (e) {
    console.log('error:', e);
  }
};

const myInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/uif/sel';
  const fetchKey = 'MY_INFO';

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    // const infoData: any = myInfo;
    const infoData: any = data;
    const { resError, resData } = dataSet(infoData, null);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
    }
  } catch (e) {
    console.log('error:', e);
  }
};

export const familyInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/dependents/lst';
  const fetchKey = 'DEPENDENTS_LIST';

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    // const infoData: any = familyInfo;
    const infoData: any = data;
    const { resError, resData } = familyDataSet(infoData, null);
    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
    }
    return resData;
  } catch (e) {
    console.log('error:', e);
  }
};

/**
  Update 개인정보 수정
*/
export const fetchUpdateMyInfoData = async (
  paramData: any,
  queryClient: any,
  setErrorState: any,
  loadingState: any,
  callback: any
) => {
  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: ['MYINFO_UPDATE', paramData],
      queryFn: () => fetchDefault(paramData, '/api/uif/upd'),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      setErrorState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};

/*
 * Insert 부양가족 추가
 */

export const fetchInsertFamilyData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/dependents/ist';
  const fetchKey = 'DEPENDENTS_INSERT';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};

/**
  Delete 부양가족 수정
*/
export const fetchUpdateFamilyData = async (
  paramData: any,
  queryClient: any,
  setErrorState: any,
  loadingState: any,
  callback: any
) => {
  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: ['DEPENDENTS_UPDATE', paramData],
      queryFn: () => fetchDefault(paramData, '/api/dependents/upd'),
    });
    console.log('[DEPENDENTS_UPDATE]', paramData, queryData);
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      setErrorState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};

/**
  Delete 부양가족 삭제
*/
export const fetchDeleteFamilyData = async (
  paramData: any,
  queryClient: any,
  setErrorState: any,
  loadingState: any,
  callback: any
) => {
  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: ['DEPENDENTS_DELETE', paramData],
      queryFn: () => fetchDefault(paramData, '/api/dependents/del'),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      setErrorState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
